import "./SuvaiContact.scss"
import store from "../../assets/images/store.png"
import seatings from "../../assets/images/seatings.png"
import reservation from "../../assets/reservation.svg"
import parking from "../../assets/parking.svg"
import privateDining from "../../assets/privateDining.svg"
import veg from "../../assets/veg.svg"

import { useSelector } from "react-redux";
import Button from "../../components/button/Button";
import { useState } from "react";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import InputComponent from "../../components/InputComponents/InputComponent";
import TextAreaComponent from "../../components/InputComponents/TextAreaComponent";
const SuvaiContact = () => {
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company)
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const data = [
        {
            "src": reservation,
            "header": "Reservations",
            "content": "Highly recommended"
        },
        {
            "src": parking,
            "header": "Parking",
            "content": "Street parking available"
        }, {
            "src": privateDining,
            "header": "Private Dining Room",
            "content": "Perfect for special occasions"
        }, {
            "src": veg,
            "header": "Vegetarian",
            "content": "Vegetarian options on request"
        },
    ]



    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        console.log(newErrors, "newErrors", fullName, email, message, phoneNumber)
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": company?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }


    const getForm = () => {
        return (
            <div className="SuvaiContact-Form">
                <InputComponent
                    placeholder={"Name"}
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value)
                        handleChange("fullName")
                    }}
                    error={errors.fullName !== ""}
                    errorText={errors.fullName}
                    required />
                <InputComponent
                    placeholder={"Email"}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    error={errors.email !== ""}
                    errorText={errors.email}
                    required />
                <InputComponent
                    placeholder={"Mobile"}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber}
                    type="number"
                    required />

                <TextAreaComponent
                    placeholder={"Message"}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    error={errors.message !== ""}
                    errorText={errors.message}
                    required />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
                </div>}

                <Button text={"SUBMIT"}
                    onClick={handleContact}
                    loading={loading} />
            </div>)
    }

    return (
        <div className="SuvaiContact">
            <div className="SuvaiContact-hero">
                <div className="SuvaiContact-hero-left" style={{ paddingTop: "125px" }}>
                    <div className="SuvaiContact-header">
                        Find Us
                    </div>
                    <div className="SuvaiContact-subheader">
                        WHERE
                    </div>
                    <div className="SuvaiContact-content">
                        {companyDetails?.address?.line1},  {companyDetails?.address?.city}, {companyDetails?.address?.postcode},
                        <br />
                        {companyDetails?.address?.state}, {companyDetails?.address?.country}
                    </div>
                    <div className="SuvaiContact-btnCont">
                        <Button text={"view map"}
                            padding={"10px 20px"}
                            width="190px" />
                        <Button text={"book a table"}
                            padding={"10px 20px"}
                            type="SECONDARY"
                            width="190px" />
                    </div>
                    <div className="SuvaiContact-subheader">
                        WHEN
                    </div>
                    <div className="SuvaiContact-content">
                        Monday – Thursday
                        <br />
                        12:00 pm – 10.00 pm   </div>
                    <div className="SuvaiContact-content">
                        Friday - Sunday<br />
                        12.00 am – 11.00 pm  </div>
                </div>
                <div className="SuvaiContact-hero-right"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${store})`
                    }} />
            </div>
            <div className="SuvaiContact-hero2">
                <div className="SuvaiContact-hero2-right"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${seatings})`
                    }} />
                <div className="SuvaiContact-hero2-left" >
                    <div className="SuvaiContact-header">
                        Get in Touch
                    </div>
                    <div className="SuvaiContact-content">
                        To get in touch fill out the contact form below or call us<br />
                        at  {companyDetails?.contactNumber}
                    </div>
                    {getForm()}

                </div>

            </div>
            <div className="SuvaiContact-grid">
                {data.map((item, index) => {
                    return (
                        <div key={index} className="SuvaiContact-grid-item">
                            <img alt="" src={item.src} className="SuvaiContact-grid-item-img" />
                            <div className="SuvaiContact-grid-item-header">{item.header}</div>
                            <div className="SuvaiContact-grid-item-content">{item.content}</div>


                        </div>
                    )
                })}
            </div>
        </div>
    )
}
export default SuvaiContact